import { IArrowData } from "@leafer-ui/interface"
import { LineData } from '@leafer-ui/draw'


export class ArrowData extends LineData implements IArrowData {

}
